import { createAction } from '@reduxjs/toolkit';
import { ITypeOfPayment } from '../../../../dto';
import { ACT_SET, MN_TYPE_OF_PAYMENTS, TYPE_ELEMENT } from '../../../../common';

export const setTypeOfPayment = createAction<ITypeOfPayment>(
  `${MN_TYPE_OF_PAYMENTS}/${TYPE_ELEMENT}/${ACT_SET}`,
);
